import React from 'react';
import {connect} from 'react-redux'
import {UncontrolledAlert} from 'reactstrap';
import {AccountActions} from '../../../actions';
import LoadingOverlay from '../../../components/LoadingOverlay';

class Verify extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
      message: '',
      loading: true
		};
  }

  componentDidMount = () => {
    let tmp = window.location.hash.split('?token=');
    let token = tmp[1];
    this.props.postEmailToken({
      token: token,
      cb: (res) => {
        console.log(res);
        this.setState({
          message: res.error ? 'Une erreur est survenue' : 'Votre email a bien été modifié',
          loading: false
        })
      }
    })
  }
    
	render () {
    const { loading, message } = this.state;
		return (
      <div
				className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
			  {
          message &&
          <UncontrolledAlert className="bg-danger text-white shadow-lg">{message}</UncontrolledAlert>
        }
        <LoadingOverlay loading={loading} message={''}/>
      </div>
		);
	}
}

const mapStateToProps = (state) => {
  return {
    userData: state.AccountReducer.userData,
    error: state.AccountReducer.error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    postEmailToken: (req) => dispatch(AccountActions.postEmailToken(req.token, req.cb))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Verify);


// WEBPACK FOOTER //
// ./app/routes/Verify/index.js